/* eslint-disable */
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import utils from '../utils/utils.functions';
import connect from '../views/axios/axios.auth';

const columnsClientes = [
  {
    name: 'Rut',
    selector: 'rut',
    sortable: true,
  },
  {
    name: 'Nombre completo',
    selector: 'name',
    sortable: true,
  },
  {
    name: 'Correo',
    selector: 'email',
    sortable: true,
  },
  {
    name: 'Telefono',
    selector: 'phone',
    sortable: true,
  },
];

const customStyles = {
rows: {
  style: {
    minHeight: '72px', // override the row height
  }
},
headCells: {
  style: {
    paddingLeft: '8px', // override the cell padding for head cells
    paddingRight: '8px',
  },
},
cells: {
  style: {
    paddingLeft: '8px', // override the cell padding for data cells
    paddingRight: '8px',
  },
},
};

let listadoFull = [];

const ClienteComponent = ({ onSeleccting, filtre, tipo }) => {

  const [limpiarSelecciones, setLimpiar] = useState(false);
  const [listado, setListado] = useState([]);
  const [pending, setPending] = useState(true);

  useEffect(() => {
    setLimpiar(!limpiarSelecciones);
  },[filtre]);

  useEffect(() => {
    listadoClientes();
  },[])

  const clientesSeleccionados = (seleccionados) => {
    onSeleccting(seleccionados, tipo);
  }

  const listadoClientes = () => {
    connect.get(`/cliente/`)
    .then((response) => {
      setListado(response.data.clientes);
      listadoFull = response.data.clientes;
      setPending(false);
    })
  }

  const buscador = (element) => {
    const resultado = utils.filterTable(listadoFull, element.target.value);
    setListado(resultado);
  }
  
  return (
    <>
    <DataTable
    title="Clientes"
    customStyles={customStyles}
    columns={columnsClientes}
    data={listado}
    dense={true}
    pagination={true}
    selectableRows={true}
    selectableRowsHighlight={true}
    clearSelectedRows={limpiarSelecciones}
    selectableRowsNoSelectAll={true}
    contextMessage={{
      singular: 'Cliente',
      plural: 'Clientes',
      message: 'seleccionados',
    }}
    onSelectedRowsChange={clientesSeleccionados}
    progressPending={pending}
    progressComponent={
      <h3>Cargando...</h3>
    }
    subHeader={true}
    subHeaderComponent={
      <div style={{ width: '40%' }}>
        <input onChange={(e) => buscador(e)} className="form-control" name="buscador" type="text" placeholder="Buscar cliente..."/>  
      </div>
    }
   />
   </>
  )
}

export default ClienteComponent;